export default __webpack_public_path__ + "static/media/icon_9.3ab33294.png";